import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Row, Col } from 'antd';
import { FaEye, FaRegHeart, FaHeart } from 'react-icons/fa';
import { HiOutlineShoppingBag } from 'react-icons/hi';
import { Link } from "react-router-dom";
import Skeleton from './Skeleton';
import secureLocalStorage from 'react-secure-storage';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import axios from 'axios';
import { toast } from 'react-toastify';
gsap.registerPlugin(ScrollTrigger);

function Card({ name, photo, previous_price, discount_price, id, isWishlisted: initialWishlisted }) {
  const cardRef = useRef(null);
  const heartRef = useRef(null);
  const eyeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [isWishlisted, setIsWishlisted] = useState(initialWishlisted);

  useEffect(() => {
    setIsWishlisted(initialWishlisted);
  }, [initialWishlisted]);

  const userId = JSON.parse(secureLocalStorage.getItem('user'))?.id;

  const addWish = async (prodId) => {
    if (!userId) {
      toast.error("Oops! Please login to save this item to your wishlist.");
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}api/add-wishlist`,
        {
          user_id: userId,
          item_id: prodId,
        }
      );

      if (res.data.data.message === "Success") {
        toast.success("Item added to your wishlist!");
        setIsWishlisted(true);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to add wishlist.");
      console.log("Adding Wishlist Error", err);
    }
  };

  useEffect(() => {
    gsap.fromTo(
      cardRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: cardRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      }
    );
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 700);
    return () => clearTimeout(timer);
  }, []);

  const handleIconHover = (ref) => {
    gsap.to(ref.current, { scale: 1.3, duration: 0.3, ease: 'power2.out' });
  };

  const handleIconLeave = (ref) => {
    gsap.to(ref.current, { scale: 1, duration: 0.3, ease: 'power2.out' });
  };

  const handleOpen = () => {
    setScrollY(window.scrollY);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    window.scrollTo(0, scrollY);
  }

  if (isLoading) return <Skeleton />;

  return (
    <div ref={cardRef}>
      <Row gutter={20} className="justify-center">
        <Col span={22}>
          <div className="main-card border border-[#43AAD5] rounded-md p-5 bg-black">
            <div className="main-custom-card justify-between flex flex-row">
              <h2 className="text-white font-syne text-2xl font-bold bg-[linear-gradient(60deg,_rgba(67,170,214,1)_80%,_rgba(0,0,1,1)_100%)] bg-clip-text text-transparent">{name}</h2>
              <ul>
                <li
                  ref={heartRef}
                  onClick={() => addWish(id)}
                  onMouseEnter={() => handleIconHover(heartRef)}
                  onMouseLeave={() => handleIconLeave(heartRef)}
                  className="text-white p-2 rounded-md border border-white cursor-pointer"
                >
                  {isWishlisted ? (
                    <FaHeart className="text-red-500" />
                  ) : (
                    <FaRegHeart />
                  )}
                </li>
                <li
                  ref={eyeRef}
                  onClick={handleOpen}
                  onMouseEnter={() => handleIconHover(eyeRef)}
                  onMouseLeave={() => handleIconLeave(eyeRef)}
                  className="text-white p-2 mt-3 rounded-md border border-white cursor-pointer"
                >
                  <FaEye />
                </li>
                {isOpen && (
                  <Lightbox
                    mainSrc={`${process.env.REACT_APP_SITE_IMAGES}${photo}`}
                    onCloseRequest={handleClose}
                    reactModalStyle={{ overlay: { zIndex: 9999 }, bodyOpen: { position: 'static' } }}
                  />
                )}
              </ul>
            </div>
            <div className="card-image flex items-center justify-center mt-5 overflow-hidden">
              <Link to={`/product/${id}`}>
                <img
                  className="w-full h-[230px] object-contain transition-transform duration-300 hover:scale-105"
                  src={`${process.env.REACT_APP_SITE_IMAGES}${photo}`}
                  alt={name}
                />
              </Link>
            </div>
            <div className="icons-part m-auto">
              <ul className="flex gap-2 items-center pt-5 justify-center mb-4">
                {previous_price && (
                  <li>
                    <span className="text-gray-400 line-through font-outfit text-[20px]">
                      ${previous_price}
                    </span>
                  </li>
                )}
                <li>
                  <span className="text-white font-outfit text-[30px]">
                    ${discount_price}
                  </span>
                </li>
              </ul>
              {/* <div className="flex justify-center items-center mt-5 mb-5 gap-3">
                <label className="cursor-pointer">
                  <input type="radio" name={`size-${id}`} className="peer hidden" />
                  <div className="px-6 font-outfit py-2 rounded-full border border-white text-white font-medium peer-checked:bg-gradient-to-r peer-checked:from-[#43AAD6] peer-checked:to-black">
                    50ml
                  </div>
                </label>
                <label className="cursor-pointer">
                  <input type="radio" name={`size-${id}`} className="peer hidden" />
                  <div className="px-6 py-2 font-outfit rounded-full border border-white text-white font-medium peer-checked:bg-gradient-to-r peer-checked:from-[#43AAD6] peer-checked:to-black">
                    100ml
                  </div>
                </label>
              </div> */}
              <Link
                to={`/product/${id}`}
                className="font-syns text-[18px] rounded-full w-full flex items-center justify-center gap-2 text-white bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] h-[50px] transition-all duration-300 hover:text-white">
                View Details
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Card;
